import React, { useMemo } from 'react';
import { theme } from '@fiverr-private/theme';
import { Grid, Center, Card } from '@fiverr-private/layout_components';
import { getPackageDetails } from '../../constants/vendors/microsoft/getPackageDetails';
import { PricingDetails, SubscriptionTier } from '../../../type';
import { PackageCardHeader } from './PackageCardHeader';
import { PackageCardAdvantages } from './PackageCardAdvantages';
import { PackageCardIcons } from './PackageCardIcons';
import * as classes from './PackageDetails.ve.css';

interface PackageDetailsProps {
    onBuyPackage: (tierName: SubscriptionTier) => void;
    pricingDetails: PricingDetails[];
}

export const PackageDetails = ({ onBuyPackage, pricingDetails }: PackageDetailsProps) => {
    const packageDetails = useMemo(() => getPackageDetails(), []);

    const lastItem = packageDetails.at(-1);
    const secondLastItem = packageDetails.at(-2);

    return (
        <Center marginBottom="2" paddingX={{ default: '4', xl: '0' }}>
            <Grid
                columnGap={{ default: '6', lg: '0' }}
                rowGap="6"
                maxWidth={theme.numericBreakpoints.xl}
                width="100%"
                templateColumns={{ default: '100%', sm: '50%_50%', lg: '25%_25%_25%_25%' }}
            >
                {packageDetails.map(({ id: tierName, vendor, shortInfo, advantages, productGroups }) => {
                    const currentPricingDetails = pricingDetails?.find(
                        (pricingDetail) => pricingDetail.tierName === tierName
                    );

                    const isLastItem = lastItem?.id === tierName;
                    const isSecondLastItem = secondLastItem?.id === tierName;

                    return (
                        <Card
                            gap="6"
                            direction="column"
                            display="flex"
                            flex="1"
                            key={tierName}
                            padding="6"
                            borderColor="grey_400"
                            marginLeft={{ default: '0', lg: isLastItem ? '6' : '0' }}
                            borderRightWidth={{ default: 'sm', lg: isSecondLastItem || isLastItem ? 'sm' : 0 }}
                            className={classes.card}
                        >
                            <PackageCardHeader
                                onBuyPackage={() => onBuyPackage(tierName)}
                                tierName={tierName}
                                vendor={vendor}
                                pricingDetails={currentPricingDetails}
                                shortInfo={shortInfo}
                            />
                            <PackageCardAdvantages advantages={advantages} />
                            <PackageCardIcons productGroups={productGroups} />
                        </Card>
                    );
                })}
            </Grid>
        </Center>
    );
};
